export default {
  RATIO: {
    RATIO_3_4: '3-4',
    RATIO_4_3: '4-3',
    RATIO_16_9: '16-9'
  },
  LOGO_VISIBILITY: {
    MOBILE: 'MOBILE'
  },
  SUBSCRIBE_VISIBILITY: {
    MOBILE: 'MOBILE'
  },
  PLAY_VISIBILITY: {
    ALWAYS: 'ALWAYS',
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
  },
  ZAPPING_NUMBER_VISIBILITY: {
    MOBILE: 'MOBILE'
  },
  ACTIONS: {
    REMOVE: 'remove'
  }
}
